import { useState, useEffect } from 'react';

const useIsPWA = (): boolean => {
  const [isPWA, setIsPWA] = useState<boolean>(() => {
    if (typeof window !== 'undefined') {
      // Check if app is running in standalone mode (PWA)
      return window.matchMedia('(display-mode: standalone)').matches ||
             (window.navigator as any).standalone === true ||
             document.referrer.includes('android-app://');
    }
    return false;
  });

  useEffect(() => {
    const checkPWAMode = () => {
      const newIsPWA = window.matchMedia('(display-mode: standalone)').matches ||
                       (window.navigator as any).standalone === true ||
                       document.referrer.includes('android-app://');
      setIsPWA(newIsPWA);
    };

    // Listen for display mode changes
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', checkPWAMode);
    } else {
      // Fallback for older browsers
      mediaQuery.addListener(checkPWAMode);
    }

    // Initial check
    checkPWAMode();

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', checkPWAMode);
      } else {
        mediaQuery.removeListener(checkPWAMode);
      }
    };
  }, []);

  return isPWA;
};

export default useIsPWA;
